var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent)?_c('div',{staticClass:"breadcrumbs-bar"},[_c('b-breadcrumb',{staticClass:"bg-transparent",attrs:{"items":_vm.items}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }